import React, { useState } from 'react';
import './Groups.less';
import { Modal, Radio } from 'antd';
import NewCustomButton from '../Common/NewCustomButton';
import { ButtonTypes } from '../Common/CustomButton';
import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { NewCloseIcon, NewUpdateIcon } from '../Common/Icons';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';

const GroupCallDeleteConfirmModal = ({
  showGroupCallDeleteConfirmModal,
  closeGroupCallDeleteConfirmModal,
  setRefreshSchedulePage,
  closeGroupModal,
  deleteScheduleCallObj,
}) => {
  const trans = useSelector(translator);
  const [loading, setLoading] = useState(false);
  const scheduleApi = useSelector((state) => state.apis.scheduleApi);

  const groupCallDeleteHandler = () => {
    setLoading(true);

    const errorCallback = (error) => {
      setRefreshSchedulePage((prev) => !prev);
      closeGroupCallDeleteConfirmModal();
      setLoading(false);
      console.error('Error deleting Event:', error);
    };
    const successCallback = (data) => {
      setRefreshSchedulePage((prev) => !prev);
      closeGroupCallDeleteConfirmModal();
      setLoading(false);
      closeGroupModal();
    };
    try {
      deleteScheduleCallObj?.recurring
        ? scheduleApi.cancelAllRecurringEvent(
            deleteScheduleCallObj?.useruuid,
            deleteScheduleCallObj?.schedule_eventuuid,
            { groupuuid: deleteScheduleCallObj?.groupuuid },
            apiCallback({
              failCallback: errorCallback,
              errorCallback,
              successCallback,
            })
          )
        : scheduleApi.cancelEvent(
            deleteScheduleCallObj?.useruuid,
            deleteScheduleCallObj?.schedule_eventuuid,
            { groupuuid: deleteScheduleCallObj?.groupuuid },
            apiCallback({
              failCallback: errorCallback,
              errorCallback,
              successCallback,
            })
          );
    } catch (error) {
      errorCallback(error);
    }
  };

  const style = {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  };
  const [value, setValue] = useState(3);
  const onChange = (e) => {
    setValue(e.target.value);
  };

  return (
    <Modal
      open={showGroupCallDeleteConfirmModal}
      onOk={closeGroupCallDeleteConfirmModal}
      onCancel={closeGroupCallDeleteConfirmModal}
      footer={null}
      closable={false}
      centered
      className="task-modal-conatiner  recurring-modal"
      tabIndex={-1}
      title={trans('DELETEPERIODICCALL')}
    >
      <div className="taskmodal">
        <div className="taskmodaldescription" style={{ fontWeight: '400', alignItems: 'center' }}>
          <Radio.Group
            style={style}
            onChange={onChange}
            value={value}
            options={[
              {
                value: 1,
                label: trans('THISOCCURRENCEONLY'),
                disabled: true,
              },
              {
                value: 2,
                label: trans('THISANDALLFUTUREOCCURRENCES'),
                disabled: true,
              },
              {
                value: 3,
                label: trans('ALLOCCURRENCES'),
              },
            ]}
          />
        </div>
        <div className="taskmodalbutton">
          <NewCustomButton
            className="cancel"
            onClick={closeGroupCallDeleteConfirmModal}
            label={trans('CANCEL')}
            icon={<NewCloseIcon className="cancel-icon" />}
          />
          <NewCustomButton
            disabled={loading}
            className="confirm"
            type={ButtonTypes.primary}
            label={loading ? trans('PROCESSING_L') : trans('YES')}
            icon={<NewUpdateIcon className={'update-icon-enabled'} />}
            onClick={groupCallDeleteHandler}
          />
        </div>
      </div>
    </Modal>
  );
};

export default GroupCallDeleteConfirmModal;
